/**
 * Method that router pages
 */
import React, {Component, useEffect} from "react";
import ReactDOM from "react-dom";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    withRouter,
} from "react-router-dom";
import MetaTags from "../components/MetaTags";
import PageHeader from "../components/pageHeader";
import AboutCompany from "../components/aboutCompany";
import PageFooter from "../components/pageFooter";
import ScrollToTop from "./ScrollToTop";
import CataloguePageHeader from "../components/cataloguePageHeader";
import ChooseCatalogue from "../components/chooseCatalogue";
import {FILE_FISH, FILE_CAGE} from "../components/openCatalogue";
import OpenCatalogue from "../components/openCatalogue";

export default class RouterPages extends Component{
    render(){
        return (
            <Router>
                <React.Fragment>
                    <Switch>
                        <Route path="/catalogue/aquarium">
                            <ScrollToTop/>
                            <MetaTags/>
                            <OpenCatalogue
                                file={FILE_FISH}
                            />
                        </Route>
                        <Route path="/catalogue/cage">
                            <ScrollToTop/>
                            <MetaTags/>
                            <OpenCatalogue
                                file={FILE_CAGE}
                            />
                        </Route>
                        <Route path="/catalogue">
                            <ScrollToTop/>
                            <MetaTags/>
                            <CataloguePageHeader/>
                            <ChooseCatalogue/>
                            <PageFooter />
                        </Route>
                        <Route path="/" >
                            {/*<ScrollToTop/>*/}
                            <MetaTags/>
                            <PageHeader />
                            <AboutCompany />
                            <PageFooter />
                        </Route>
                    </Switch>
                </React.Fragment>
            </Router>
        )
    }
}
